import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import en from './locales/en.json';
import ar from './locales/ar.json';
import arMA from './locales/ar-MA.json';
import fr from './locales/fr.json';
import de from './locales/de.json';
import es from './locales/es.json';

// Only classical Arabic (ar) uses RTL. Moroccan Darija (ar-MA) uses Latin script and is LTR.
const RTL_LANGS = ['ar'];

function applyRTL(lng) {
  const normalized = (lng || '').toLowerCase();
  const isRTL = RTL_LANGS.includes(normalized) && !normalized.startsWith('ar-ma');
  const html = document.documentElement;
  html.setAttribute('dir', isRTL ? 'rtl' : 'ltr');
  html.setAttribute('lang', lng || 'en');
  html.classList.toggle('rtl', isRTL);
}

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      ar: { translation: ar },
      'ar-MA': { translation: arMA },
      fr: { translation: fr },
      de: { translation: de },
      es: { translation: es },
    },
    fallbackLng: 'en',
    supportedLngs: ['en', 'ar', 'ar-MA', 'fr', 'de', 'es'],
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
      lookupLocalStorage: 'bazzef_lang',
    },
  });

i18n.on('languageChanged', (lng) => {
  applyRTL(lng);
});

// Apply on init
const initial = i18n.language || i18n.resolvedLanguage || 'en';
applyRTL(initial);

export default i18n;
